import { Checkbox, FormControlLabel } from '@mui/material';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TenantSelectorProps } from './AvailabilityPreview.types';
import { edit as editAvailability } from 'FRONTEND/reducers/availabilitySlice';
import i18n from 'FRONTEND/utils/i18n';
import { store } from 'LEGACY/reactTreeMounting';
type RootState = ReturnType<typeof store.getState>;

const TenantSelector = ({ allCurrentUserTenants, managedExpert, currentAvailability }: TenantSelectorProps) => {
  const dispatch = useDispatch();
  const currentUserId = useSelector((state: RootState) => state.user.id);

  const isManagedExpert = managedExpert.id !== currentUserId;
  // Tenant management
  const commonTenants = useMemo(() => {
    if (isManagedExpert) {
      return Object.fromEntries(
        Object.entries(allCurrentUserTenants).filter(([id]) => managedExpert.tenantList.includes(id)),
      );
    } else {
      return allCurrentUserTenants;
    }
  }, [managedExpert, allCurrentUserTenants, isManagedExpert]);

  const handleTenantListChange = (tenantId: string, newValue: boolean) => {
    let newTenants: string[];
    if (currentAvailability.tenantList.includes(tenantId) && !newValue) {
      newTenants = currentAvailability.tenantList.filter(el => el !== tenantId);
      dispatch(editAvailability({ ...currentAvailability, tenantList: newTenants }));
    } else if (!currentAvailability.tenantList.includes(tenantId) && newValue) {
      newTenants = [...currentAvailability.tenantList, tenantId];
      dispatch(editAvailability({ ...currentAvailability, tenantList: newTenants }));
    }
  };

  // Select/Deselect all tenants management
  const handleSelectAllTenantsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      dispatch(editAvailability({ ...currentAvailability, tenantList: Object.keys(commonTenants) }));
    } else {
      dispatch(editAvailability({ ...currentAvailability, tenantList: [] }));
    }
  };
  const isAllChecked = Object.keys(commonTenants).every((tenantId) =>
    currentAvailability.tenantList.includes(tenantId),
  );
  const isIndeterminate = Object.keys(commonTenants).some((tenantId) => currentAvailability.tenantList.includes(tenantId)) && !isAllChecked;
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            indeterminate={isIndeterminate}
            checked={isAllChecked}
            onChange={handleSelectAllTenantsChange}
          />
              }
        label={i18n._('Select/Deselect all')}
      />
      {Object.values(commonTenants).map((tenant) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={currentAvailability.tenantList.includes(tenant.id)}
              onChange={(event) => {
                handleTenantListChange(tenant.id, event.target.checked);
              }}
            />
                }
          value={tenant.id}
          key={tenant.id}
          label={tenant.name}
        />
      ))}
    </>
  );
};

export default TenantSelector;
